import type {
  ApiObject,
  RudderAnalytics,
  RudderAnalyticsPreloader,
} from '@rudderstack/analytics-js'

import { getRudderAnalytics } from '../renderer/rudderstack'

declare global {
  interface Window {
    rudderanalytics: RudderAnalytics | RudderAnalyticsPreloader | undefined
  }
}
export const track = ({
  eventName,
  eventData,
}: {
  eventName: string
  eventData?: ApiObject
}) => {
  const analytics = getRudderAnalytics()
  if (analytics) {
    analytics.track(eventName, eventData)
  } else {
    console.info('[analytics]', eventName, eventData)
  }
}
